import { render, staticRenderFns } from "./table-top-panel.vue?vue&type=template&id=6dbd85b2&scoped=true"
import script from "./table-top-panel.vue?vue&type=script&lang=js"
export * from "./table-top-panel.vue?vue&type=script&lang=js"
import style0 from "./table-top-panel.vue?vue&type=style&index=0&id=6dbd85b2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd85b2",
  null
  
)

export default component.exports